module.exports = __webpack_public_path__ + "media/images/common/side_cart_bg_btm-84316b0c3279a8ffe64a7e929c71f979.gif";